import React from "react";
import AlignVerticalBottomIcon from "@mui/icons-material/AlignVerticalBottom";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Inventory2TwoToneIcon from "@mui/icons-material/Inventory2TwoTone";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import RadarIcon from "@mui/icons-material/Radar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShoppingCartTwoToneIcon from "@mui/icons-material/ShoppingCartTwoTone";
import StackedBarChartTwoToneIcon from "@mui/icons-material/StackedBarChartTwoTone";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import { Application } from "./application";
import { CollectionsStarIcon } from "./collections-star-icon";
import {
    canAccessPositioningBeta,
    hasAccessToMonorepo,
    hasAdminRole,
    requiresApplication,
} from "./menu-validation-rules";
import { MisProductosIcon } from "./misproductos-icon";
import { MULTI_PRODUCT_ROUTES } from "./multi-product-routes";
import { ShoppingBagIcon } from "./shopping-bag-icon";

export const MENU_TREE_ITEMS = [
    {
        title: "Configurar tienda",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Mis productos",
                path: MULTI_PRODUCT_ROUTES.PRODUCTOS,
                icon: <MisProductosIcon />,
                validationRules: [requiresApplication],
                application: Application.PRODUCTOS,
            },
        ],
    },
    {
        title: "Visión general",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Panorama competitivo",
                path: MULTI_PRODUCT_ROUTES.MANAGEMENT_SUMMARY,
                icon: <ShoppingBagIcon />,
                validationRules: [requiresApplication],
                application: Application.MANAGEMENT_SUMMARY,
            },
        ],
    },
    {
        title: "Precios",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Competitividad de mi ecommerce",
                path: MULTI_PRODUCT_ROUTES.ECOMMERCE,
                icon: <ShoppingCartTwoToneIcon />,
                validationRules: [requiresApplication],
                application: Application.PHOENIX,
            },
            {
                title: "Mercado completo",
                path: "https://mivistamercado.retailcompass.com/",
                icon: <StackedBarChartTwoToneIcon />,
                validationRules: [requiresApplication],
                application: Application.SCALIBUR,
            },
            {
                title: "Competitividad de sellers (3P)",
                path: `${MULTI_PRODUCT_ROUTES.MARKETPLACE}/farming`,
                icon: <CollectionsStarIcon />,
                validationRules: [requiresApplication],
                application: Application.MARKETPLACE,
            },
        ],
    },
    {
        title: "Visibilidad",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Posicionamiento",
                path: MULTI_PRODUCT_ROUTES.POSITIONING,
                icon: <RadarIcon />,
                badge: "Beta",
                accent: "success",
                pulse: true,
                optionEvent: "POSITIONING_BETA",
                validationRules: [canAccessPositioningBeta],
            },
            {
                title: "Comparar vitrinas",
                path: MULTI_PRODUCT_ROUTES.RANKING,
                icon: <CompareArrowsIcon />,
                validationRules: [requiresApplication],
                application: Application.RANKING,
            },
        ],
    },
    {
        title: "Surtido",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Surtido de productos",
                path: MULTI_PRODUCT_ROUTES.ASSORTMENT,
                icon: <Inventory2TwoToneIcon />,
                validationRules: [requiresApplication],
                application: Application.ASSORTMENT,
            },
            {
                title: "Encontrar nuevos sellers",
                path: `${MULTI_PRODUCT_ROUTES.MARKETPLACE}/hunting`,
                icon: <ManageSearchIcon />,
                validationRules: [requiresApplication],
                application: Application.MARKETPLACE,
            },
        ],
    },
    {
        title: "Reportes",
        icon: <FiberManualRecordIcon />,
        children: [
            {
                title: "Reporte de salud de clientes",
                path: MULTI_PRODUCT_ROUTES.CUSTOMER_REPORT,
                icon: <AlignVerticalBottomIcon />,
                validationRules: [hasAdminRole, hasAccessToMonorepo],
                optionEvent: "HEALTH_ADMIN",
            },
            {
                title: "Mi reporte de salud",
                path: `${MULTI_PRODUCT_ROUTES.ECOMMERCE}/health`,
                icon: <StackedLineChartIcon />,
                validationRules: [requiresApplication],
                application: Application.PHOENIX,
                optionEvent: "HEALTH_CLIENT",
            },
        ],
    },
    {
        title: "Configuración",
        icon: <FiberManualRecordIcon />,
        hideHeader: true,
        pinToBottom: true,
        children: [
            {
                title: "Configuración",
                path: "https://app.retailcompass.com/configuracion/perfil/mis-datos",
                icon: <SettingsOutlinedIcon />,
                optionEvent: "CONFIGURATION",
            },
        ],
    },
];
